// extracted by mini-css-extract-plugin
module.exports = {"antdCard":"Card_antdCard__VTWZ2"};